module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/post-golpes-lno-7792c5da82bde8c8de474f539e11d71e.png";